import React from "react";
import Sidebar from "./Sidebar";
import Content from "./Content";
import { ConfirmProvider } from "material-ui-confirm";

const Layout = ({ children, isNewUserAdded, setAuth }) => {
  return (
    <div className="layout">
      <Sidebar isNewUserAdded={isNewUserAdded} setAuth={setAuth} />
      <Content>
        <ConfirmProvider>{children}</ConfirmProvider>
      </Content>
    </div>
  );
};

export default Layout;
